import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { isAndroid, isIOS } from "react-device-detect";
import { APP_STORE_URL, PLAY_STORE_URL } from "./common/InstallApp/links";

/**
 * #1264: `/get-app`, where the website's get-the-app link
 * (`https://link.farmflix.tv/get-app`, `GET_APP_LINK`) lands when the phone
 * doesn't have the app (the link domain sends it to `/link/get-app`, and
 * `utils/linkRoutes.ts` sends that here). A phone with the app opens the app
 * instead and doesn't come here.
 *
 * An iPhone goes straight to the App Store and an Android phone to Google
 * Play, replacing this page in the history so Back doesn't bounce the visitor
 * into the store again. The device test is react-device-detect's `isIOS` /
 * `isAndroid`, as the install block's INSTALL THE APP button picks its store
 * (`common/InstallApp/HeroLayout.tsx`). Anything else (a computer, a smart-TV
 * browser, an iPad whose browser reports itself as a Mac) lands on `/app`,
 * the install page. No page of its own.
 *
 * The store hand-off runs in an effect, as `ExternalRedirect` in Routes.js
 * does: under StrictMode's dev double-render a render-body assignment would
 * fire twice (#637).
 */
const GetAppRedirect = () => {
  const storeUrl = isIOS ? APP_STORE_URL : isAndroid ? PLAY_STORE_URL : null;

  useEffect(() => {
    if (storeUrl) {
      window.location.replace(storeUrl);
    }
  }, [storeUrl]);

  if (!storeUrl) {
    return <Navigate to="/app" replace />;
  }
  return null;
};

export default GetAppRedirect;
